var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "position-relative px-0" }, [
    _c(
      "div",
      {
        staticClass: "container mw-100 border-gray mobile-tile mb-0 bg-white",
        class: _vm.isSelected ? "selected-tile" : "",
      },
      [
        _c("div", { staticClass: "col-12 px-0 bg-header-tile" }, [
          _c("div", { staticClass: "row" }, [
            _vm.offer.showPicto5G
              ? _c("img", {
                  staticClass: "logo-5g",
                  attrs: { src: _vm.offer.picto5gSrc, alt: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.offer.banner
              ? _c("div", { staticClass: "col-10 pb-2" }, [
                  _c("div", { staticClass: "col-auto p-0" }, [
                    _c(
                      "div",
                      { staticClass: "row align-items-center mobile-banner" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-auto p-0 padding-bottom-banner" },
                          [
                            _c(
                              "div",
                              { staticClass: "ob1-tag ob1-tag-primary" },
                              [_c("span", [_vm._v(_vm._s(_vm.offer.banner))])]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.offer.timerEndDateInMilliseconds
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto p-0 padding-left-tag padding-bottom-banner",
                              },
                              [
                                _c("timer", {
                                  attrs: {
                                    "end-date-in-milliseconds":
                                      _vm.offer.timerEndDateInMilliseconds,
                                    color: _vm.offer.countDownColor
                                      ? _vm.offer.countDownColor
                                      : "text-dark",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ])
              : _c("div", { staticClass: "col-12 pb-2" }, [
                  _c("div", { staticClass: "mobile-banner" }),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "mobile-title-align" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("h2", { staticClass: "visually-hidden" }, [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.offer.name) +
                        "\n                            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "pt-xl-1 py-0 mb-0 fw-bold",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.offer.offerType) +
                          "\n                            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.offer.secondaryShortLabel
                    ? _c(
                        "h2",
                        {
                          staticClass: "h1 py-0 mb-0",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.offer.secondaryShortLabel) +
                              "\n                            "
                          ),
                        ]
                      )
                    : _c(
                        "h2",
                        {
                          staticClass: "h4 py-0 mb-0",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.offer.name) +
                              "\n                            "
                          ),
                        ]
                      ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("Price", {
                  staticClass: "mobile-price-align",
                  attrs: {
                    price: _vm.offer.price.price,
                    "initial-price": _vm.offer.price.initialPrice,
                    "price-details": _vm.offer.price.priceDetails
                      ? _vm.offer.price.priceDetails
                      : undefined,
                    "show-from": _vm.offer.price.showFrom,
                    "show-by-month": _vm.offer.price.showByMonth,
                    "show-promo-duration": _vm.offer.price.showPromoDuration,
                    "show-promo-duration-first-months":
                      _vm.offer.price.showPromoDurationFirstMonths,
                    "show-end-of-promotion-price":
                      _vm.offer.price.showEndOfPromotionPrice,
                    "show-children-promotion-price":
                      _vm.offer.price.showChildrenPromotionPrice,
                    duration: _vm.offer.price.duration,
                    "is-cents-format": false,
                    "is-compact": _vm.offer.price.compact,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 pb-1" }, [
              _c("div", { staticClass: "mobile-promo" }, [
                _vm.offer.discountLabel
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "bg-greige p-1 d-flex align-items-center justify-content-center",
                      },
                      [
                        _c("span", {
                          staticClass:
                            "alert-icon icon-phone-fund-euro text-primary font-size-28 me-1",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ob1-alert-title fw-bold" }, [
                          _vm._v(_vm._s(_vm.formattedDiscountLabel)),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 pb-1" }, [
              _c("div", { staticClass: "mobile-odr" }, [
                _vm.offer.monthlyOdrs
                  ? _c("div", [
                      _c(
                        "ul",
                        {
                          staticClass: "row list-unstyled mb-0",
                          attrs: { "aria-label": "Offres de remboursement" },
                        },
                        _vm._l(_vm.offer.monthlyOdrs, function (odr, index) {
                          return _c(
                            "li",
                            { key: index },
                            [
                              _c("InlinePromise", {
                                attrs: {
                                  claim: { attributes: { textHtml: odr } },
                                  "is-warning": true,
                                  "compact-text": true,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.offer.foLink
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ob1-link-arrow",
                      attrs: {
                        href: _vm.offer.foLink,
                        "data-oevent-category": _vm.offer.foTms.category,
                        "data-oevent-action": _vm.offer.foTms.action,
                        "data-oevent-label": _vm.offer.foTms.label,
                      },
                    },
                    [_vm._v("Découvrir cette offre")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 p-1" }, [
              _vm.isSelected
                ? _c("div", { staticClass: "mobile-selection h-100" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100",
                      },
                      [
                        _c("span", {
                          staticClass: "icon icon-tick-circle",
                          staticStyle: { "font-size": "1.5rem" },
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "lead fw-bold ms-1",
                          domProps: { textContent: _vm._s(_vm.buttonLabel) },
                        }),
                      ]
                    ),
                  ])
                : _c(
                    "div",
                    { staticClass: "mobile-selection d-flex flex-column" },
                    [
                      _c("button", {
                        staticClass: "btn btn-secondary",
                        staticStyle: {
                          "padding-left": "0",
                          "padding-right": "0",
                        },
                        attrs: {
                          type: "button",
                          "data-oevent-category":
                            _vm.offer.selectButtonTms.category,
                          "data-oevent-action":
                            _vm.offer.selectButtonTms.action,
                          "data-oevent-label": _vm.offer.selectButtonTms.label,
                        },
                        domProps: { textContent: _vm._s(_vm.buttonLabel) },
                        on: {
                          click: function ($event) {
                            return _vm.onSelectOffer()
                          },
                        },
                      }),
                    ]
                  ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm._l(
                  _vm.offer.attributes,
                  function (attribute, attributeIndex) {
                    return _c(
                      "div",
                      {
                        key: "attribute-without-update-" + attributeIndex,
                        staticClass: "mobile-attributes",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center pb-1" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-shrink-0 mobile-attribute-image me-1",
                              },
                              [
                                _c("span", {
                                  staticClass: "icon lead text-primary",
                                  class: attribute.image
                                    ? attribute.image
                                    : "icon-tick",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-grow-1" }, [
                              _c("div", {
                                staticClass: "font-size-14",
                                domProps: {
                                  innerHTML: _vm._s(attribute.description),
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                _vm.offer.claims
                  ? _c("div", { staticClass: "mobile-attributes" }, [
                      _c(
                        "ul",
                        { staticClass: "row list-unstyled" },
                        _vm._l(_vm.offer.claims, function (claim, index) {
                          return _c(
                            "li",
                            { key: `claim-${index}` },
                            [_c("InlinePromise", { attrs: { claim: claim } })],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }